const adminTranslation = {
  mode: 'en',
  menu: 'Administrator',
  toolMenu: 'Tools',
  billingDataMenu: 'Row data',
  billingDataRecordings: 'Recordings row data',
  billingDataBabyAi: 'BabyViewAis row data',
  billingDataDescription:
    'Review the source rows used for settlement by period and account, then download them as CSV.',
  billingDataFilterTitle: 'Filters',
  billingDataFilterDescription:
    'Choose a settlement month or custom range, then narrow the data by seq, barcode, account, and status.',
  billingDataPeriodMode: 'Date selection mode',
  billingDataThisMonth: 'This month',
  billingDataLastMonth: 'Last month',
  billingDataBillingMonth: 'Settlement month',
  billingDataCustomPeriod: 'Custom range',
  billingDataPeriod: 'Date range',
  billingDataResultTitle: 'Row data results',
  billingDataResultDescription:
    'Review rows on screen or download every row matching the current filters as CSV.',
  billingDataRecordingsNotice:
    'Shows the same fields and January 1, 2026 recording cutoff used by the daily Recordings sheet. Choose Updated At to find older rows whose status changed recently.',
  billingDataBabyAiNotice:
    'Shows the current BabyView AI exposure and billing status. Choose Created At for new rows or Updated At for changed rows.',
  billingDataExportNotice:
    'CSV is generated sequentially from current production data and only one export can run at a time. Reconcile the full billing period before finalizing charges.',
  billingDataSeq: 'Seq',
  billingDataBarcode: 'Barcode',
  billingDataDevice: 'Device',
  billingDataHospital: 'Account',
  billingDataRoom: 'Room',
  billingDataClientCode: 'Client Code',
  billingDataDeleted: 'Deleted',
  billingDataVideoLength: 'Video Length',
  billingDataRecordedAt: 'Recorded At',
  billingDataCapturedAt: 'Captured At',
  billingDataCreatedAt: 'Created At',
  billingDataUpdatedAt: 'Updated At',
  billingDataNet30: 'Net 30',
  billingDataVisible: 'Visible',
  billingDataBillable: 'Billable',
  billingDataWebhookSentAt: 'Webhook Sent At',
  billingDataSearchLabel: 'Seq or barcode',
  billingDataSearchPlaceholder: 'Enter an exact seq or barcode',
  billingDataAllHospitals: 'All accounts',
  billingDataDateBasis: 'Date basis',
  billingDataDateRange: 'Date range',
  billingDataSearch: 'Search',
  billingDataDownloadCsv: 'Download filtered CSV',
  billingDataResultCount: '{{count}} rows',
  billingDataDownloading: 'Downloading CSV. Large exports can take several minutes.',
  billingDataCancelDownload: 'Cancel',
  billingDataDownloadCancelled: 'CSV creation was cancelled.',
  billingDataDownloadStarted: 'The CSV download has started.',
  billingDataDownloadSuccess: 'The CSV download is complete.',
  billingDataDownloadError: 'The CSV could not be created. Please try again shortly.',
  billingDataSearchError: 'The billing data could not be loaded. Please try again.',
  billingDataSearchFirst: 'Set filters and click Search.',
  crystalRevealPromptMenu: 'Crystal Reveal Prompts',
  crystalRevealUsageMenu: 'Crystal Reveal Usage',
  crystalRevealUsageTitle: 'Crystal Reveal Usage',
  crystalRevealUsageDescription:
    'Review actual generation and compare it with the immediately preceding equal period.',
  crystalRevealUsageFilterTitle: 'Filters',
  crystalRevealUsageFilterDescription:
    'Choose a quick month or custom range and studio, or find a session by barcode.',
  crystalRevealUsagePeriodMode: 'Date selection mode',
  crystalRevealUsageThisMonth: 'This month',
  crystalRevealUsageLastMonth: 'Last month',
  crystalRevealUsageBillingMonth: 'Settlement month',
  crystalRevealUsageCustomPeriod: 'Custom range',
  crystalRevealUsagePeriod: 'Date range',
  crystalRevealUsageStudio: 'Studio',
  crystalRevealUsageStudioSelect: 'All studios',
  crystalRevealUsageStudios: 'Studios',
  crystalRevealUsageStudiosCaption: 'Report scope',
  crystalRevealUsageSessions: 'Sessions',
  crystalRevealUsageSessionsCaption: 'Generated sessions',
  crystalRevealUsageSession: 'Session',
  crystalRevealUsageRecording: 'Recording',
  crystalRevealUsageCapture: 'Capture',
  crystalRevealUsageComparisonPeriod: 'Previous equal period',
  crystalRevealUsageComparisonColumn: 'Vs. previous',
  crystalRevealUsageComparisonLoading: 'Comparing',
  crystalRevealUsageComparisonUnavailable: 'No comparison',
  crystalRevealUsageComparisonError:
    'Previous-period usage could not be loaded. Current-period totals remain available.',
  crystalRevealUsageNewUsage: 'New',
  crystalRevealUsageNoChange: 'No change',
  crystalRevealUsageSharpDrop: 'Sharp drop',
  crystalRevealUsagePreviousCount: 'Previous {{count}}',
  crystalRevealUsageDifferenceCount: 'Change {{count}}',
  crystalRevealUsageSharpDropAlert: 'Usage dropped sharply at {{count}} studios.',
  crystalRevealUsageSharpDropDescription:
    'Total generation fell by at least 50% compared with {{startDate}} through {{endDate}}.',
  crystalRevealUsageSharpDropCount: '{{count}} sharp drops',
  crystalRevealUsageBarcode: 'Barcode',
  crystalRevealUsageBarcodeSearch: 'Search barcode',
  crystalRevealUsageBarcodeMismatch: 'Barcode mismatch',
  crystalRevealUsageGenerationLimitExceeded: 'Generation limit exceeded',
  crystalRevealUsageGenerationLimitExceededHelp:
    'Basic 5, Bonus 5, and Motion8K 2 are per-session maximums, not required output. Only sessions above a limit are flagged.',
  crystalRevealUsageGenerationLimitExceededDetail:
    'Actual vs. maximum: Basic {{basic}}/5 · Bonus {{bonus}}/5 · Motion8K {{motion8k}}/2',
  crystalRevealUsageLastGeneratedAt: 'Last generated at',
  crystalRevealUsageGeneratedTotal: 'Total generated',
  crystalRevealUsageGeneratedCaption: 'Billing basis',
  crystalRevealUsageVisibleTotal: 'Shown in app',
  crystalRevealUsageVisibleCaption: 'As of now',
  crystalRevealUsageGeneratedGroup: 'All generated',
  crystalRevealUsageVisibleGroup: 'Shown in app',
  crystalRevealUsageTotal: 'Total',
  crystalRevealUsageStudioSummary: 'Studio summary',
  crystalRevealUsageSessionDetail: 'Session details',
  crystalRevealUsageResultTitle: 'Usage results',
  crystalRevealUsageResultDescription:
    'Review studio totals and trends alongside actual generation and limit warnings by session.',
  crystalRevealUsageDownload: 'Studio CSV',
  crystalRevealUsageSessionDownload: 'Session CSV',
  crystalRevealUsageSessionDownloadError:
    'The session CSV could not be created. Please try again shortly.',
  crystalRevealUsageVisibleNotice:
    'The app exposure count reflects the current state, not a historical snapshot.',
  crystalRevealUsageTimezoneNotice:
    'Counts generation records from {{startDate}} through {{endDate}} in {{timezone}}.',
  auditLogMenu: 'Audit Log',
  auditLogTitle: 'Audit Log',

  createTestBarcodeTitle: 'Generate Test Barcode',
  uploadRecordingTitle: 'Upload Ultrasound Video',
  uploadCaptureTitle: 'Upload Ultrasound Capture',

  barcode: 'Barcode',
  hospital: 'Account',
  recordedAt: 'Upload Date',
  hospitalRoom: 'Room',
  selectHospitalRoom: 'Select Room/Mommybox',
  create: 'Generate',
  upload: 'Upload',
  uploadRecording: 'Upload Video',
  uploadCapture: 'Upload Capture',
  selectRecording: 'Select Recording',
  selectRecordingPlaceholder: 'Please select a recording',
  capturedAt: 'Capture Time',
  captureFile: 'Capture File',

  createTestBarcode: 'Success: Test Barcode Generated.',
  completeUploadRecording: 'Completed: Ultrasound Video Uploaded',
  failUploadRecording: 'Error: Ultrasound Video Upload Failed',
  completeUploadCapture: 'Completed: Ultrasound Capture Uploaded',
  failUploadCapture: 'Error: Ultrasound Capture Upload Failed',
  uploadCompleteMessage: 'Complete: file uploaded, updating video information.',
  uploadFailMessage:
    'Error: Failed to update video information, there may be an issue with the video.',
  uploadProgress: 'Upload Progress',
  uploadStatusUploading: 'Transferring file',
  uploadStatusForwarding: 'Server is forwarding the upload.',
  uploadStatusProcessing: 'Upload complete, updating video information.',
  uploadStatusPending: 'Processing on server',
  uploadCanceledMessage: 'Upload canceled. Your form values were kept for retry.',
  cancelUpload: 'Cancel Upload',
  uploadTransferred: 'Transferred',
  uploadSpeed: 'Upload Speed',
  uploadRemainingTime: 'Estimated Time Left',
  uploadRemainingTimePending: 'Unavailable',
  uploadElapsedTime: 'Elapsed Time',
  hourUnit: 'h',
  minuteUnit: 'm',
  secondUnit: 's',
  barcodeValidateMessage: 'Error: your input should be an 11-digit numerical code',
  recordingValidateMessage: 'Please upload a video file in the correct format.',
  captureValidateMessage: 'Please upload an image file in the correct format.',
  recordingRequiredMessage: 'Please select a recording',
  capturedAtRequiredMessage: 'Please select capture time',
  captureFileRequiredMessage: 'Please upload a capture file',
  requiredFieldsMessage: 'Please fill in all required fields',
  validationErrorMessage: 'Please check the input values',
  selectRecordingDescription: 'Please select a recording to upload capture',
  selectedRecording: 'Selected Recording',
  noRecordingsFound: 'No recordings found',

  excelHospital: 'hospital',
  excelDevice: 'mommybox',
  excelRecording: 'ultrasound',
  excelCapture: 'ultrasound capture',
  googleSheetDownloadTitle: 'Excel Download',
  googleSheetDownloadSelection: 'Excel Download Items',
  selectExcelType: 'Select Item',
  downloadExcel: 'Download Excel',
  barcodeLabel: 'Barcode:',
  videoLength: 'Video Length',
  searchRecordingsErrorMessage:
    'An error occurred while searching for recordings. Please try again.',
};

export default adminTranslation;
